<script>
	export let ctx = {
		apiURL : "http://localhost:3000"
	}
	console.log("context", ctx)
	import Router from 'svelte-spa-router'
	import routes from "./routes.js"


</script>



<main>
	<Router {routes}></Router>
</main>



<style>
	main {
		text-align: center;
		padding: 1em;
		/* max-width: 240px; */
		margin: 0 auto;
		background-color: #fff;
		box-sizing: border-box;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
			height: 100%;
		}
	}
</style>